<template>
  <div>
    <common-dialog ref="dialog" width="1300px" unit="图片查看" id-key="UserId" in-dialog
      @close-saved="$emit('close-saved')">
      <div class="demo-image">
        <div class="block" v-for="(item, index) in imgs" :key="'a' + index">
          <el-image style="width: 100px; height: 100px" :src="item" fit="fill" :preview-src-list="imgs"></el-image>
        </div>
      </div>
      <template slot="footer">
        <el-button type="success" @click="printPic">打印图片</el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    imgs: {
      type: Array,
      default: () => []
    },
    id: {
      type: Number,
      default: 0
    }
  },
  methods: {
    printPic() {
      let path = "/bomPicPrint?id=" + this.id;
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
  }
};
</script>

<style lang="scss" scoped>
.demo-image {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.block {
  margin: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
}
</style>
